// StripePolicyPage.jsx
import React, { useState } from "react";
import policyData from "../../stripeElakayPolicie.json";
import { getElakayLang } from "../auth";
import { elakayAutoText, getElakayLanguageContext } from "./dataElakay";


let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
// Current language source: the app-wide one (always up to date after a language switch), else
// the infoSource this module last rendered with.
const __elakayLanguageSource = () => getElakayLanguageContext?.() || __elakayInfoSource;
const __elakayText = (key, fallback) =>
  __elakayLanguageSource()?.laguangeElakay?.("frontElakayHardcodedText", __elakayLanguageSource().languageAPI)?.["stripeElakayPolicyPage"]?.[key] || fallback;

// Sélectionne la bonne langue du JSON
// function getStripePolicyByLang() {
//   const { obj } = getElakayLang() || {};
//   const { code } = obj || { code: "fr" };

//   const found = policyData.find((p) => p.language === code);
//   return found || policyData.find((p) => p.language === "en");
// }
function getStripePolicyByLang(ids = []) {
  const { obj } = getElakayLang() || {};
  const { code } = obj || { code: "fr" };

  // Trouver le bon document selon la langue
  const policy =
    policyData.find((p) => p.language === code) ||
    policyData.find((p) => p.language === "en");

  if (!policy || !Array.isArray(policy.sections)) {
    return policy || null;
  }

  // Si aucun id fourni → retourner le policy COMPLET
  if (!ids.length) {
    return policy;
  }

  // Convertir ids en string
  const idStrings = ids.map(String);

  // Créer une copie du policy avec sections filtrées
  return {
    ...policy,
    sections: policy.sections.filter(section =>
      idStrings.includes(section.id)
    )
  };
}

// Styles basiques pour une belle mise en page
const containerStyle = {
  maxWidth: "960px",
  margin: "40px auto",
  padding: "24px",
  fontFamily: "system-ui, sans-serif",
  color: "#111827",
};

const cardStyle = {
  background: "#fff",
  borderRadius: "16px",
  padding: "20px 24px",
  marginBottom: "16px",
  boxShadow: "0 10px 25px rgba(0,0,0,0.05)",
  border: "1px solid #e5e7eb",
};

const buttonStyle = {
  marginTop: "12px",
  padding: "6px 14px",
  borderRadius: "999px",
  border: "1px solid #d1d5db",
  backgroundColor: "#f9fafb",
  cursor: "pointer",
  fontSize: "13px",
  fontWeight: 500,
};

const paginationWrapperStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginTop: "30px",
};

const paginationButtonStyle = (disabled) => ({
  padding: "8px 16px",
  borderRadius: "999px",
  border: "1px solid #d1d5db",
  backgroundColor: disabled ? "#f3f4f6" : "#111827",
  color: disabled ? "#9ca3af" : "#fafafa",
  cursor: disabled ? "not-allowed" : "pointer",
  fontSize: "13px",
  fontWeight: 500,
});

function getPreview(text, maxChars = 420) {
  if (!text) return "";
  if (text.length <= maxChars) return text;
  return text.slice(0, maxChars) + "…";
}

const StripePolicyPage = ({ infoSource }) => {
  __setElakayInfoSource(infoSource);
  const ids = [];
  const policy = getStripePolicyByLang(ids);

  const sections = policy?.sections || [];

  const pageSize = 4;
  const [page, setPage] = useState(0);
  const [expandedSections, setExpandedSections] = useState({});

  const totalPages = Math.ceil(sections.length / pageSize);

  const startIndex = page * pageSize;
  const endIndex = startIndex + pageSize;

  const currentSections = sections.slice(startIndex, endIndex);

  const toggleExpand = (id) => {
    setExpandedSections((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  return (
    <main style={containerStyle}>
      {/* Header */}
      <header>
        <h1 style={{ fontSize: "28px", fontWeight: "700" }}>{policy?.title}</h1>
        <p
          style={{
            marginTop: "12px",
            background: "#f9fafb",
            padding: "16px",
            borderRadius: "12px",
            border: "1px solid #e5e7eb",
            lineHeight: 1.6,
          }}
        >
          {policy?.summary}
        </p>
      </header>

      {/* Affichage des sections */}
      {currentSections
      .map((section) => {
        const isExpanded = expandedSections[section.id];
        const previewText = getPreview(section.body);

        return (
          <article key={section.id} style={cardStyle}>
            <div
              style={{
                fontSize: "12px",
                color: "#6b7280",
                textTransform: "uppercase",
                marginBottom: "6px",
              }}
            >{__elakayText("t001", "Section")}{section.id}
            </div>

            <h2 style={{ fontSize: "18px", fontWeight: "600" }}>
              {section.title}
            </h2>

            {/* Texte complet ou résumé */}
            {isExpanded ? (
              section.body
                .split("\n\n")
                .map((paragraph, idx) => (
                  <p key={idx} style={{ lineHeight: 1.6 }}>{paragraph}</p>
                ))
            ) : (
              <p style={{ lineHeight: 1.6 }}>{previewText}</p>
            )}

            {/* Bouton See more / See less */}
            <button
              style={buttonStyle}
              onClick={() => toggleExpand(section.id)}
            >
              {isExpanded ? elakayAutoText("h_47c77bf0a809f2", "See less") : elakayAutoText("h_c510d6c04c0951", "See more")}
            </button>
          </article>
        );
      })}

      {/* Pagination Previous / Next */}
      <div style={paginationWrapperStyle}>
        <button
          style={paginationButtonStyle(page === 0)}
          disabled={page === 0}
          onClick={() => setPage((p) => p - 1)}
        >{__elakayText("t002", "Previous")}</button>

        <span style={{ fontSize: "13px", color: "#6b7280" }}>{__elakayText("t003", "Page")}{page + 1} / {totalPages}
        </span>

        <button
          style={paginationButtonStyle(page === totalPages - 1)}
          disabled={page === totalPages - 1}
          onClick={() => setPage((p) => p + 1)}
        >{__elakayText("t004", "Next")}</button>
      </div>
    </main>
  );
};

export default StripePolicyPage;
